import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepper = ["内容入力", "機構へ提出"];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "契約者（法人）名",
    keyword: "contractorName",
    type: "text",
    showLine: false,
  },
  {
    keyword: "title",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    title: "転換予定日",
    keyword: "changeoverDueDate",
    type: "date",
    disabled: true,
  },
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle:
      "社会福祉施設等から特定介護保険施設等に転換する施設の情報を確認してください。",
  },
  {
    title: "施設名",
    keyword: "bFacilityName",
    type: "selectForm",
    disabled: true,
  },
  {
    title: "転換前施設種類",
    keyword: "bFacilityKind",
    type: "label",
    disabled: true,
  },
  {
    title: "転換前施設所在地郵便番号",
    keyword: "bFacilityZipcode",
    type: "postcode",
    disabled: true,
  },
  {
    title: "転換前施設所在地",
    keyword: "bFacilityAddress",
    type: "locationGroup",
    disabled: true,
  },
  {
    keyword: "title2",
    type: "lineTitle",
    lineTitle: "転換後の施設情報を確認してください。",
  },
  {
    title: "転換後施設名称",
    keyword: "aFacilityName",
    type: "label",
    disabled: true,
  },
  {
    title: "転換後施設種類",
    keyword: "aFacilityKind",
    type: "label",
    disabled: true,
  },
  {
    title: "転換後施設所在地郵便番号",
    keyword: "aFacilityZipcode",
    type: "addressSearch",
    disabled: true,
  },
  {
    title: "転換後施設所在地",
    keyword: "aFacilityAddress",
    type: "locationGroup",
    disabled: true,
  },
  {
    title: "備考",
    keyword: "remark",
    type: "textarea",
    disabled: false,
  },
];

const schema = {
  remark: {
    maxLength: {
      value: 2000,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "2000"),
    },
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
  },
};

export { stepper, fakeTableList, schema };
